<div class="history-imported-dialog">
  <!-- Start customer history Header -->
  <div class="history-imported-header mb-0" *ngIf="!isEstiamteLoading">
    <div class="ui-g-12 flex-between-center py-0">
      <div class="flex-between-center w-100 py-2">
        <div class="flex-start-center">
          <i class="far fa-redo font-20 font-gray-45 header-icon"></i>
          <div class="pl-1 history-imported-description p-relative">
            <p class="m-0 font-secondary-700 font-14 font-bold">
              <span *ngIf=" estimate && estimate?.code">RO# {{estimate?.code}}: </span>
              <span>{{estimate?.title}}</span>
              <span *ngIf="estimate?.orderStatus === 'invoice'">
                (Invoice # {{estimate?.invCode}})
              </span>
              <span *ngIf="estimate?.orderStatus === 'estimate'">
                (Estimate # {{estimate?.code}})
              </span>
            </p>
          </div>
        </div>
        <div class="flex-end-center">
          <button class="btn btn-border mr-3" (click)="printEstimate()">
            <i class="fas fa-print mr-2"></i>Print
          </button>
          <i id="history-imported-close-dialog" class="far fa-times pointer dialog-close="
          (click)="handleCloseModal()"></i>
        </div>
      </div>
    </div>
  </div>

  <!-- Start customer history Body -->
  <div class="ui-g history-imported-body pt-0 pb-0 border-bottom-light" *ngIf="!isEstiamteLoading">
    <div class="ui-g-12 inputs-column-spacing history-imported-inner-body">
      <!-- Basic Info section -->
      <div class="input-basic-info-wrapper input-default-style ui-g-12 p-0">
        <h5 class="input-heading font-14">Basic details</h5>
        <div class="ui-g-12 p-0 input-control-container">
          <div class="ui-g-6 p-0 flex-start-center">
            <div class="icon flex-center-start">
              <i class="far fa-users height-icon"></i>
            </div>

            <div class="width-100p pl-1 pr-2">
              <app-input placeholder="Customer name" [theme]="errors?.model? 'primary' : 'light'" [floatingLabel]="true"
                [isInvalid]="errors?.displayName" [value]="estimate?.customer?.displayName" [disabled]="true">
              </app-input>
            </div>
          </div>

          <div class="ui-g-6 p-0 flex-start-center">
            <div class="icon flex-center-start">
              <i class="far fa-car height-icon"></i>
            </div>
            <div class="orderSubActivity? width-100p pl-1 pr-2">
              <app-input placeholder="Customer vehicle" [theme]="errors?.model? 'primary' : 'light'"
                [floatingLabel]="true" [isInvalid]="errors?.vehicle" [value]="estimate?.vehicle?.name" [disabled]="true">
              </app-input>
            </div>
          </div>
        </div>

        <div class="ui-g-12 p-0 input-control-container mt-3">
          <div class="ui-g-6 p-0 flex-start">
            <div class="icon flex-center-start">
              <i class="far fa-comment-alt height-icon"></i>
            </div>

            <div class="width-100p pl-1 pr-2 cc_area">
              <app-textarea placeholder="Customer concern" [theme]="errors?.model? 'primary' : 'light'"
                [floatingLabel]="true" [isInvalid]="errors?.customerNotes" [value]="estimate?.customerNotes"
                [disabled]="true">
              </app-textarea>
            </div>
          </div>

          <div class="ui-g-6 p-0 flex-start">
            <div class="icon flex-center-start">
              <i class="far fa-sticky-note height-icon"></i>
            </div>
            <div class="orderSubActivity? width-100p pl-1 pr-2 cc_area">
              <app-textarea placeholder="Shop note" [theme]="errors?.model? 'primary' : 'light'" [floatingLabel]="true"
                [isInvalid]="errors?.shopNotes" [value]="estimate?.shopNotes" [disabled]="true">
              </app-textarea>
            </div>
          </div>
        </div>

        <div class="ui-g-12 p-0 input-control-container mt-3">
          <div class="ui-g-6 p-0 flex-start-center">
            <div class="icon flex-center-start">
              <i class="far fa-tachometer-alt-slow height-icon"></i>
            </div>

            <div class="width-100p pl-1 pr-2">
              <app-input placeholder="Mileage" [theme]="errors?.model? 'primary' : 'light'" [floatingLabel]="true"
                [isInvalid]="errors?.mileage" [value]="estimate?.mileage" [disabled]="true">
              </app-input>
            </div>
          </div>

          <div class="ui-g-6 p-0 flex-start-center">
          </div>
        </div>

        <div class="ui-g-12 p-0">
          <p-tabView class="tab-panel-underline tab-panel-estimates tab-panel-default" (onChange)="selectedTab = $event.index">
            <!-- Start Summary Section -->
            <p-tabPanel header="Summary" [selected]="selectedTab === 0">
              <div class="ui-g-12">
                <div class="ui-g-6">
                  <div class="summary-left-section">
                    <div class="ui-g-12 px-1 pt-0 pointer pb-1"
                      (click)="toggleOrderDetails('isTotalDetailsVisible', $event)">
                      <div class="ui-g-9 p-0 flex-start-center left-heading font-gray-light hover-underline">
                        <p class="font-secondary-900 mb-0 font-14 pointer">
                          Parts + Labor + Tire + Other
                          <i class="ml-1 fal fa-chevron-down font-11 pointer" *ngIf="!isTotalDetailsVisible"></i>
                          <i class="ml-1 fal fa-chevron-up font-11 pointer" *ngIf="isTotalDetailsVisible"></i>
                        </p>
                      </div>

                      <div class="ui-g-3 p-0 text-right font-14 right-heading font-secondary-900 pointer hover-underline">
                        {{(estimate?.total?.total || 0) | currency: usd}}
                      </div>
                    </div>
                    <!-- Parts total -->
                    <div class="ui-g-12 pt-1 pl-1 pr-1 pb-0" *ngIf="isTotalDetailsVisible">
                      <div class="ui-g-9 p-0 flex-start-center left-heading font-light">
                        <p class="mb-0 font-14">
                          Parts:
                        </p>
                      </div>

                      <div class="ui-g-3 p-0 text-right font-14 right-heading font-light pointer">
                        {{estimate?.total?.parts | currency: usd}}
                      </div>
                    </div>

                    <!-- Labor total -->
                    <div class="ui-g-12 pt-1 pl-1 pr-1 pb-0" *ngIf="isTotalDetailsVisible">
                      <div class="ui-g-9 p-0 flex-start-center left-heading font-light">
                        <p class="mb-0 font-14">
                          Labor:
                        </p>
                      </div>

                      <div class="ui-g-3 p-0 text-right font-14 right-heading font-light pointer">
                        {{estimate?.total?.labor | currency: usd}}
                      </div>
                    </div>

                    <!-- Tire total -->
                    <div class="ui-g-12 pt-1 pl-1 pr-1 pb-0" *ngIf="isTotalDetailsVisible">
                      <div class="ui-g-9 p-0 flex-start-center left-heading font-light">
                        <p class="mb-0 font-14">
                          Tire:
                        </p>
                      </div>

                      <div class="ui-g-3 p-0 text-right font-14 right-heading font-light pointer">
                        {{estimate?.total?.tire | currency: usd}}
                      </div>
                    </div>

                    <!-- Other total -->
                    <div class="ui-g-12 p-1" *ngIf="isTotalDetailsVisible">
                      <div class="ui-g-9 p-0 flex-start-center left-heading font-light">
                        <p class="mb-0 font-14">
                          Other:
                        </p>
                      </div>

                      <div class="ui-g-3 p-0 text-right font-14 right-heading font-light pointer">
                        {{estimate?.total?.other | currency: usd}}
                      </div>
                    </div>

                    <!-- Start Service Discount -->
                    <div class="ui-g-12 p-1 font-gray-light font-14">
                      <div class="font-secondary-900 ui-g-9 p-0 flex-start-center left-heading">
                        Service Discount
                      </div>
                      <div class="font-secondary-900 ui-g-3 p-0 text-right right-heading font-14">
                        ({{estimate?.total?.itemDiscountedAmount | currency: usd}})
                      </div>
                    </div>
                    <!-- End Service Discount -->

                    <!-- Start Fee -->
                    <div class="ui-g-12 p-1 font-gray-light font-14">
                      <div class="font-secondary-900 ui-g-9 p-0 flex-start-center left-heading">
                        Fees (Hazmat / EPA)
                      </div>
                      <div class="font-secondary-900 ui-g-3 p-0 text-right right-heading font-14">
                        {{estimate?.total?.hazmatFee | currency: usd}}
                      </div>
                    </div>
                    <!-- End Fee -->

                    <!-- Start Order Discount -->
                    <div class="ui-g-12 p-1 font-gray-light font-14">
                      <div class="font-secondary-900 ui-g-9 p-0 flex-start-center left-heading">
                        Order Discount
                      </div>
                      <div class="font-secondary-900 ui-g-3 p-0 text-right right-heading font-14">
                        ({{estimate.total.discountedAmount | currency: usd}})
                      </div>
                    </div>
                    <!-- End Order Discount -->

                    <!-- Start Shop supplies -->
                    <div class="font-secondary-900 ui-g-12 p-1 font-gray-light font-14">
                      <div class="ui-g-9 p-0 service-shop-supplies-overlay flex-start-center">
                        <app-content-overlay right="40" [showArrow]="false">
                          <ng-template appTemplate="item">
                            <span class="hover-underline">
                              Shop&nbsp;supplies&nbsp;
                            </span>
                          </ng-template>
                        </app-content-overlay>
                      </div>

                      <div class="font-secondary-900 ui-g-3 p-0 flex-end-center">
                        <span id="order-shop-supplies-link" class="font-secondary-900">
                          <p class="m-0 font-14">
                            {{estimate.total?.shopFee || 0 | currency: usd}}
                          </p>
                        </span>
                      </div>
                    </div>
                    <!-- End Shop supplies -->

                    <!-- Start Order Tax -->
                    <div class="ui-g-12 p-1 font-gray-light font-14 hover-underline pointers">
                      <div class="ui-g-9 p-0 flex-start-center total-tax-overlay left-heading">
                        <p class="font-light mb-0 font-14">
                          Taxes ({{estimate?.taxValues?.taxRate}} %)
                        </p>
                      </div>
                      <div class="font-gray-light ui-g-3 p-0 text-right right-heading font-14">
                        {{estimate?.total?.taxedAmount | currency: usd}}
                      </div>
                    </div>
                    <!-- End Order Tax -->

                    <!-- Start Taxable -->
                    <div class="ui-g-12 pt-1 pl-1 pr-1 " *ngIf="isTaxDetailsVisible">
                      <div class="ui-g-9 p-0 flex-start-center left-heading font-gray-light">
                        <p class="font-light mb-0 font-14  ml-2">
                          Taxable:
                        </p>
                      </div>

                      <div class="font-light ui-g-3 p-0 text-right font-14 right-heading pointer">
                        {{estimate?.total?.taxableAmount || 0 | currency: usd}}
                      </div>
                    </div>
                    <!-- End Taxable -->

                    <!-- Start Non-Taxable: -->
                    <div class="ui-g-12 p-1" *ngIf="isTaxDetailsVisible">
                      <div class="ui-g-9 p-0 flex-start-center left-heading font-light">
                        <p class="font-light mb-0 font-14 ml-2">
                          Non-Taxable:
                        </p>
                      </div>

                      <div class="font-light ui-g-3 p-0 text-right font-14 right-heading pointer">
                        {{estimate?.total?.nonTaxableAmount || 0 | currency: usd}}
                      </div>
                    </div>
                    <!-- Start Non-Taxable: -->

                    <!-- Start Estimate total -->
                    <div class="ui-g-12 p-0 font-gray-light font-14">
                      <div class="font-secondary-900 ui-g-9 p-1 flex-start-center font-bold left-heading">
                        {{orderTitle}} total
                      </div>

                      <div class="ui-g-3 p-1 text-right right-heading b-top-gray-75">
                        <span class="font-secondary-900 font-bold font-14">
                          {{estimate?.total?.grand || 0 | currency: usd}}
                        </span>
                      </div>
                    </div>
                    <!-- End Estimate total -->

                    <!-- Start Paid to date -->
                    <div class="ui-g-12 p-0 font-gray-light font-14 ">
                      <div class="font-secondary-900 ui-g-9 p-1 flex-start-center left-heading font-14">
                        Paid to date
                      </div>

                      <div class="ui-g-3 p-1 text-right right-heading b-top-gray-75">
                        <span class="font-secondary-900 font-14">
                          {{estimate?.total?.paid || 0 | currency: usd}}
                        </span>
                      </div>
                    </div>
                    <!-- End Paid to date -->

                    <!-- Start remaining balance -->
                    <div class="ui-g-12 p-0 font-gray-light font-14">
                      <div class="font-secondary-900 ui-g-9 p-1 flex-start-center font-bold left-heading">
                        Remaining balance
                      </div>

                      <div class="ui-g-3 p-1 text-right right-heading b-bottom-double-gray-85 b-top-double-gray-85 "
                        style="border-bottom-width: 2px;">
                        <span class="font-secondary-900 font-bold font-14 ">
                          {{estimate?.total?.unpaid || 0 | currency: usd}}
                        </span>
                      </div>
                    </div>
                    <!-- End remaining balance -->

                    <!-- End Item totals -->
                  </div>
                </div>

                <div class="ui-g-6">
                  <div class="summary-right-section">
                    <div class="ui-g-12 p-1">
                      <div class="ui-g-9 p-0 flex-start-center left-heading font-light">
                        <p class="mb-0 font-14 font-bold">
                          Order no.
                        </p>
                      </div>

                      <div *ngIf="estimate?.code"
                        class="ui-g-3 p-0 text-right font-14 right-heading font-light pointer font-900">
                        #{{ estimate?.code || '-' }}
                      </div>
                    </div>
                    <div class="ui-g-12 p-1">
                      <div class="ui-g-9 p-0 flex-start-center left-heading font-light">
                        <p class="mb-0 font-14 font-bold">
                          Order status.
                        </p>
                      </div>

                      <div *ngIf="estimate?.orderStatus"
                        class="ui-g-3 p-0 text-right font-14 right-heading font-light pointer font-900">
                        {{estimate?.orderStatus === 'invoice'? 'Invoice': 'Estimate' }}
                      </div>
                    </div>
                    <div class="ui-g-12 p-1" *ngIf="estimate?.isPaidFull">
                      <div class="ui-g-9 p-0 flex-start-center left-heading font-light">
                        <p class="mb-0 font-14 font-bold">
                          Payment status.
                        </p>
                      </div>

                      <div *ngIf="estimate?.isPaidFull"
                        class="ui-g-3 p-0 text-right font-14 right-heading font-light pointer font-900">
                        {{ estimate?.isPaidFull ? 'Paid' : 'Unpaid' }}
                      </div>
                    </div>
                    <div class="ui-g-12 p-1" *ngIf="estimate?.invoiceDate">
                      <div class="ui-g-9 p-0 flex-start-center left-heading font-light">
                        <p class="mb-0 font-14 font-bold">
                          Invoice
                        </p>
                      </div>

                      <div *ngIf="estimate?.invoiceDate"
                        class="ui-g-3 p-0 text-right font-14 right-heading font-light pointer font-900">
                        {{estimate?.invoiceDate | date: 'MMM d, yyyy' }}
                      </div>
                    </div>

                    <div class="ui-g-12 p-1 line"></div>

                    <!-- Payment history Start -->
                    <div class="payment-history">
                      <div class="ui-g-12 mt-2">
                        <div class="ui-g-9 p-0 flex-start-center left-heading font-light">
                          <p class="mb-0 font-14 font-bold">
                            Payment history
                          </p>
                        </div>
                        <div class="ui-g-3 p-0 text-right font-14 right-heading font-light pointer font-900">
                        </div>
                      </div>
                      <div class="ui-g-12 pb-0 flex-column" *ngFor="let payment of paymentHistory">
                        <div class="ui-g-9 p-0 flex-between-center font-light">
                          <p class="mb-0 font-14 ">
                            {{ payment?.paymentType }} -
                            {{ payment?.paymentDateTime | date: 'MMM d, yyyy' }}
                          </p>

                          <div class="ui-g-3 p-0 text-right font-14 right-heading font-light pointer">
                            {{ payment?.amount || 0 | currency: usd }}
                          </div>
                        </div>
                        <p class="m-0 font-12">Confirmation number: {{payment?.confirmationNo}}</p>
                        <p class="m-0 font-12">Notes: {{payment?.paymentNotes}}</p>

                      </div>
                    </div>
                    <!-- Payment history End -->
                  </div>
                </div>
              </div>
            </p-tabPanel>
            <!-- End Summary Section -->

            <!-- Start Service items Section -->
            <p-tabPanel header="Service items" [selected]="selectedTab === 1">
              <div *ngFor="let service of serviceItems">
                <div class="mt-4">
                  <p class="font-14 font-bold">{{service?.title}}</p>
                </div>
                <div class="ui-g-12 p-0 ">
                  <div class="table">
                    <div class="table-header flex-start-center">
                      <div class="table-heading type font-600 flex-start-center">
                        Type
                      </div>

                      <div class="table-heading name font-600 text-truncate flex-start-center">
                        Name
                      </div>

                      <div class="table-heading description font-600  text-truncate flex-start-center">
                        Description
                      </div>

                      <div class="table-heading cost font-600  flex-start-center">
                        Cost/unit
                      </div>

                      <div class="table-heading price font-600  flex-start-center">
                        Price/unit
                      </div>

                      <div class="table-heading qty font-600  flex-start-center">
                        Quantity
                      </div>

                      <div class="table-heading amount font-600  flex-start-center">
                        Amount
                      </div>

                      <div class="table-heading discount font-600 flex-start-center">
                        Discount
                      </div>

                      <div class="table-heading net-amount font-600  flex-start-center">
                        Net amount
                      </div>

                      <div class="table-heading taxable font-600 flex-start-center">
                        Taxable
                      </div>
                    </div>

                    <div class="table-header flex-start-center" *ngFor="let item of service?.items">
                      <div class="item type  flex-start-center capitalize">
                        {{labels[item.type]}}
                      </div>
                      <div class="item name text-truncate tuncate-text flex-start-center" tooltipPosition="top"
                        [pTooltip]="item.title">
                        {{item.title}}
                      </div>
                      <div class="item description text-truncate tuncate-text flex-start-center" tooltipPosition="top"
                        [pTooltip]="item.description">
                        {{item.description}}
                      </div>
                      <div class="item cost flex-start-center" style="float: left;">
                        {{item.cost || 0 | currency: usd}}
                      </div>
                      <div class="item price flex-start-center" style="float: left;">
                        {{item.price || 0| currency: usd}}
                      </div>
                      <div class="item qty flex-start-center">
                        {{item.count || 0 }}
                      </div>
                      <div class="item amount flex-start-center" style="float: left;">
                        {{item.subTotal || 0 | currency: usd}}
                      </div>
                      <div class="item discount flex-start-center" style="float: left;">
                        {{item.discountAmt || 0 | currency: usd}}
                      </div>
                      <div class="item net-amount flex-start-center">
                        {{item.netSubTotal || 0 | currency: usd}}
                      </div>
                      <div class="item taxable flex-start-center">
                        {{item.isTaxable ? 'Yes': 'No'}}
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </p-tabPanel>
            <!-- End Service items Section -->

            <!-- Start Deferred items Section -->
            <p-tabPanel header="Deferred items" [selected]="selectedTab === 2">
              <div *ngFor="let service of deferredItems">
                <div class="mt-4">
                  <p class="font-14 font-bold">{{service?.title}}</p>
                </div>
                <div class="ui-g-12 p-0 ">
                  <div class="table">
                    <div class="table-header flex-start-center">
                      <div class="table-heading type font-600 flex-start-center">
                        Type
                      </div>

                      <div class="table-heading name font-600 text-truncate flex-start-center">
                        Name
                      </div>

                      <div class="table-heading description font-600  text-truncate flex-start-center">
                        Description
                      </div>
                      <div class="table-heading cost font-600  flex-start-center">
                        Cost/unit
                      </div>


                      <div class="table-heading price font-600  flex-start-center">
                        Price/unit
                      </div>

                      <div class="table-heading qty font-600  flex-start-center">
                        Quantity
                      </div>

                      <div class="table-heading amount font-600  flex-start-center">
                        Amount
                      </div>

                      <div class="table-heading discount font-600 flex-start-center">
                        Discount
                      </div>

                      <div class="table-heading net-amount font-600  flex-start-center">
                        Net amount
                      </div>

                      <div class="table-heading taxable font-600 flex-start-center">
                        Taxable
                      </div>
                    </div>

                    <div class="table-header flex-start-center" *ngFor="let item of service?.items">
                      <div class="item type  flex-start-center capitalize">
                        {{labels[item.type]}}
                      </div>

                      <div class="item name text-truncate tuncate-text flex-start-center" tooltipPosition="top"
                        [pTooltip]="item.title">
                        {{item.title}}
                      </div>

                      <div class="item description text-truncate tuncate-text flex-start-center" tooltipPosition="top"
                        [pTooltip]="item.description">
                        {{item.description}}
                      </div>

                      <div class="item cost flex-start-center" style="float: left;">
                        {{item.cost || 0 | currency: usd}}
                      </div>

                      <div class="item price flex-start-center" style="float: left;">
                        {{item.price || 0 | currency: usd}}
                      </div>

                      <div class="item qty flex-start-center">
                        {{item.count || 0}}
                      </div>

                      <div class="item amount flex-start-center" style="float: left;">
                        {{item.subTotal || 0 | currency: usd}}
                      </div>

                      <div class="item discount flex-start-center" style="float: left;">
                        {{item.discountAmt || 0 | currency: usd}}
                      </div>

                      <div class="item net-amount flex-start-center">
                        {{item.netSubTotal || 0 | currency: usd}}
                      </div>

                      <div class="item taxable flex-start-center">
                        {{item.isTaxable ? 'Yes': 'No'}}
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </p-tabPanel>
            <!-- End Deferred items Section -->

          </p-tabView>
        </div>
      </div>
      <!-- Basic info section ends -->
    </div>

    <!-- <div class="ui-g-12 inputs-column-spacing history-imported-inner-body">

    </div> -->
  </div>

  <!-- Start customer history Footer -->
  <div class="ui-g-12 flex-between-center dialog-footer part-footer p-0">
    <div class="part-add-dialog-footer d-flex justify-content-between width-100p" *ngIf="!isEstiamteLoading">
      <div>
      </div>

      <div>
        <button class="btn btn-primary btn-submit" (click)="!handleCloseModal()">
          <span>Close</span>
        </button>
      </div>
    </div>
  </div>

  <div class="flex-start-start p-2 width-100p height-100p" *ngIf="isEstiamteLoading">
    <!-- <span class="pr-2">Loading...</span> -->
    <!-- <i class="fal fa-spinner rotate"></i> -->
  </div>
</div>
